module.exports = __webpack_public_path__ + "static/img/banner.a1b68dfa.png";